import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6e57463f&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-header.scss?vue&type=style&index=0&id=6e57463f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e57463f",
  null
  
)

export default component.exports